import { createPinia } from 'pinia';

export const store = createPinia();

export * from './device.ts';
export * from './family.ts';
export * from './message.ts';
export * from './profile.ts';
